<template>
    <div>Redirecionando</div>
</template>
<script>
import page from '@/api/page'

export default {
    name:'Permalink',
    methods:{
        async redirect() {
            let id = this.$route.params.id

            const response = await page.get(id)
            
            if (response.ok) {
                this.$router.push(response.data.url)
            }
        }
    },
    mounted() {
        this.redirect()
    }
}
</script>